import React from "react";

/**
 * Wrapper around React.lazy that handles stale chunk errors after deployment.
 * If a chunk fails to load (likely due to stale chunks after deploy),
 * it reloads the page to fetch fresh chunks.
 *
 * @param importer - Function that returns a promise resolving to a module with a default export
 * @returns A lazy-loaded component that will reload the page on chunk load errors
 */
export function lazyWithReload<T extends React.ComponentType<any>>(
  importer: () => Promise<{ default: T }>,
): React.LazyExoticComponent<T> {
  return React.lazy(async () => {
    try {
      return await importer();
    } catch (e) {
      // Likely stale chunk after deploy
      window.location.reload();
      // Return a never-resolving promise to satisfy types (reload will happen)
      return new Promise<any>(() => {});
    }
  }) as React.LazyExoticComponent<T>;
}
